import React from 'react'
import classnames from 'classnames'

import style from './style.css'

export default function ProjectIcon( props ) {
  const { project } = props

  let content

  if ( !project.icon || typeof project.icon !== 'string' ) {
    content = (
      <img className={style.image} src="/assets/images/logo_avatar.png" alt={project.name} />
    )
  } else if ( project.icon.indexOf( 'http' ) === 0 || project.icon.indexOf( 'https' ) === 0 ) {
    content = (
      <img className={style.image} src={project.icon} alt={project.name} />
    )
  } else {
    content = <i className={classnames( project.icon, style.image )} />
  }

  return (
    <div className={style.projectIcon}>
      {content}
    </div>
  )
}
